import { render, staticRenderFns } from "./Harbours.vue?vue&type=template&id=274b68e0&scoped=true"
import script from "./Harbours.vue?vue&type=script&lang=ts"
export * from "./Harbours.vue?vue&type=script&lang=ts"
import style0 from "./Harbours.vue?vue&type=style&index=0&id=274b68e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274b68e0",
  null
  
)

export default component.exports